export function getNodes<T>(
  data:
    | { edges?: ({ node?: T | null | undefined } | null)[] | null | undefined }
    | undefined,
  filter?: (node: T) => boolean
) {
  return (
    data?.edges?.reduce<T[]>((acc, cur) => {
      if (!cur?.node) return acc
      if (!!filter && !filter(cur.node)) return acc

      acc.push(cur.node)
      return acc
    }, []) ?? []
  )
}
